export const timeShiftLegends = [
  {
    label: 'Normal time shift',
    color: '#8c2b81',
    backgroundColor: '#f5ecf4',
  },
  {
    label: 'Week Off',
    color: '#f15858',
    backgroundColor: '#fef2f2',
  },
  {
    label: 'Flexible time shift',
    color: '#41ce75',
    backgroundColor: '#dcfce7',
  },
  {
    label: 'No time shift',
    color: '#9ca3af',
    backgroundColor: '#f3f4f6',
  },
  {
    label: 'Overnight',
    color: '#FAD02C',
    backgroundColor: '#666666',
  },
  {
    label: 'On Leave',
    color: '#2196F3',
    backgroundColor: '#d6ecfd',
  },
  {
    label: 'Holiday',
    color: '#9ca3af',
    backgroundColor: '#f3f4f6',
  },
];
